import { Link } from '@mui/material';
import { getEditorColor, renderColor } from '../../util/ColorUtil';
import { getObjectValueByMachineName } from '../../util/ObjectUtil';
import { useRouter } from 'next/router';
import {
  correctInternalLink,
  getEditorColors,
  isItUndefined,
  isLinkAbsolute,
  modifyLinks,
} from '../../util/DataUtil';
import { cleanHTML } from '../utils/htmlUtils';

const TemplateProduct = (props) => {
  const dataSet = Object.assign(
    {},
    props?.facilityData,
    props?.metroData,
    props?.locationData,
    props?.regionData
  );
  const productCount =
    props?.children?.field_product?.product_paragraph_type.length;
  const router = useRouter();
  const emphasizedTextColor = getEditorColors(
    isItUndefined(props?.children?.field_formatted_title),
    isItUndefined(props?.children?.field_sub_title),
    isItUndefined(props?.children?.field_description)
  ).filter((x) => x)[0];

  const handleProductClick = (item) => {
    if (isLinkAbsolute(item?.field_link[0]?.uri)) {
      window.open(item?.field_link[0]?.uri, '_blank');
    } else {
      router.push(correctInternalLink(item?.field_link[0]?.uri));
    }
  };

  //function for making product card to be right clickable

  // const handleContextMenu = (e, item) => {
  //     e.preventDefault();
  //     const internalLink = correctInternalLink(item?.field_link[0]?.uri);
  //     const absoluteUrl = window.location.origin + internalLink;
  //     window.open(absoluteUrl, '_blank');
  // };

  const renderProducts = (data) => {
    if (!data) return;

    return data.map((item, key) => (
      <div
        className={`div-product-link product ${getEditorColor(props?.children?.field_formatted_title[0]?.value)}`}
        key={`product-index-${key}`}
        onClick={() => handleProductClick(item)}
        // onContextMenu={(e) => handleContextMenu(e, item)}
      >
        <span className="product-title">{item?.field_title[0]?.value}</span>
        <span className="product-description">
          {cleanHTML(item?.field_description_long[0]?.value)}
        </span>
        <Link
          className={'a-product-link'}
          target={isLinkAbsolute(item?.field_link[0]?.uri) ? '_blank' : '_self'}
          href={correctInternalLink(item?.field_link[0]?.uri)}
          legacybehavior="true"
        >
          <span className="product-link">{item?.field_link[0]?.title}</span>
        </Link>
      </div>
    ));
  };

  return (
    <div
      className={`template-product ${renderColor(props?.children?.field_text_color[0]?.value, props?.regionColor)}`}
    >
      <div className="inner-container">
        <div className="product-wrapper">
          <span
            dangerouslySetInnerHTML={{
              __html: cleanHTML(
                modifyLinks(
                  isItUndefined(props?.children?.field_formatted_title)
                )
              ),
            }}
            className={`product-title ${emphasizedTextColor ? emphasizedTextColor : ''}`}
          ></span>
          <span
            dangerouslySetInnerHTML={{
              __html: cleanHTML(
                modifyLinks(
                  getObjectValueByMachineName(
                    props?.children?.field_sub_title[0]?.value,
                    dataSet
                  )
                )
              ),
            }}
            className={`product-subtitle ${emphasizedTextColor ? emphasizedTextColor : ''}`}
          ></span>
        </div>
        <span
          dangerouslySetInnerHTML={{
            __html: cleanHTML(
              modifyLinks(
                getObjectValueByMachineName(
                  props?.children?.field_description[0]?.value,
                  dataSet
                )
              )
            ),
          }}
          className={`product-description ${emphasizedTextColor ? emphasizedTextColor : ''}`}
        ></span>
        <div className={'products'}>
          {renderProducts(
            props?.children?.field_product?.product_paragraph_type
          )}
        </div>
      </div>
    </div>
  );
};

export default TemplateProduct;
